// ReportSSatisfactionLevelPage.tsx

import React, { useCallback, useEffect, useState } from "react";
import { shallow } from "zustand/shallow";
import { useHeaderStore } from "../../../../../store/header.store";

import style from "./ReportSatisfactionLevel.module.css";
import styleForm from "../../../../../common/theme/styles/form.module.css";
import styleDataTable from "../../../../../common/UI/DataTable/dataTable.module.css";

import ProgressBar from "../../../../../common/UI/ProgressBar";
import InputSearch from "../../../../../common/UI/DataTable/inputSearch";
import useFormattedDate from "../../../../../common/hooks/useFormattedDate";

import { GetReportSatisfactionLevelService } from "../../../services/Reports/getReportSatisfactionLevel.service";
import { GetAnalyticsFiltersService } from "../../../../../common/services/getAnalyticsFilters.service";
import { subDays } from "date-fns";
import ChartComponent from "../../../components/chart";
import DataTable from "../../../../../common/UI/DataTable/dataTable";
import { GetSessionsWithPaginationService } from "../../../services/Reports/getSessionsWithPagination.service";
import AppInputSearchFilter from "../../../../../common/UI/Inputs/appInputSearchFilter";
import AppButton from "../../../../../common/UI/Buttons/AppButton"
import { GetInquiryDetailsBySessionService } from "../../../services/dashboard/getInquiryDetailsBySession.service"
import Modal from "../../../../../common/UI/Modal"
import { ConversationViewer } from "../../../components/ConversationViewer"
import ConatinerFilter from "../../../../../common/UI/DataTable/filterModal/containerFilter";
import { GetWidgetsFilterWithPaginationService } from "../../../services/getWidgetsFilterWithPagination.service";
import { DataSelectDto } from "../../../../../common/dtos/general.dto";

interface ChannelValues {
  channelName: string;
  values: number[];
}

interface InquiryAnalyticsResponse {
  dates: string[];
  channelValues: ChannelValues[];
}

interface ConversationMessage {
  inquiryId: string;
  inquiryDate: string;
  citizenId: string | null;
  procedureTypeId: string | null;
  question: string;
  userInquiry: string;
  inquiryForever: string;
  inquiryDateTime: string;
  inquiryGetDay: string;
  inquiryStart: string;
  inquiryGetMinute: string;
  responseGeneratedDate: string;
  responseGenerated: string;
  userFeedback: string | null;
}

const getSessionsWithPaginationService = new GetSessionsWithPaginationService();

export default function ReportSSatisfactionLevelPage() {
  const headerStore = useHeaderStore(
    (state) => ({
      setModule: state.setModule,
      setModuleItem: state.setModuleItem,
    }),
    shallow
  );

  const hFormatDate = useFormattedDate();
  const today = new Date();

  const [dataChannels, setDataChannels] = useState<{ label: string; value: string }[]>([]);
  const [dataCountsTypes, setDataCountsTypes] = useState<{ label: string; value: string }[]>([]);

  const [selectChannels, setSelectChannels] = useState<{ label: string; value: number }[]>([]);
  const [selectCountsTypes, setSelectCountsTypes] = useState<{ label: string; value: string } | null>(null);

  const [startDateSatisfactionLevel, setStartDateSatisfactionLevel] = useState<Date>(subDays(today, 7));
  const [endDateSatisfactionLevel, setEndDateSatisfactionLevel] = useState<Date>(today);

  const [loading, setLoading] = useState(false);
  const [responseDataGraphSatisfactionLevel, setResponseDataGraphSatisfactionLevel] = useState<InquiryAnalyticsResponse | null>(null);
  const [seriesData, setSeriesData] = useState<any[]>([]);
  const [optionsData, setOptionsData] = useState<any>({});

  const [isReloadData, setIsReloadData] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [conversationMessages, setConversationMessages] = useState<ConversationMessage[]>([]);
  const [loadingConversation, setLoadingConversation] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [widgetFilter, setWidgetFilter] = useState<DataSelectDto>({
    label: '',
    value: ''
  });
  const getDataSatisfactionLevel = useCallback(async () => {
    setLoading(true);
    const params = {
      startDate: hFormatDate(startDateSatisfactionLevel, "yyyy-MM-dd"),
      endDate: hFormatDate(endDateSatisfactionLevel, "yyyy-MM-dd"),
      channelIds: selectChannels.map((c: any) => c.value),
      status: selectCountsTypes ? selectCountsTypes.value : "",
      widgetId: widgetFilter ? widgetFilter.value : "",
    };
    setIsReloadData(!isReloadData);

    try {
      const response = await GetReportSatisfactionLevelService(params);
      setResponseDataGraphSatisfactionLevel(response || null);
    } catch (error) {
      console.error("Error fetching total consultations:", error);
      setResponseDataGraphSatisfactionLevel(null);
    } finally {
      setLoading(false);
    }
  }, [endDateSatisfactionLevel, selectChannels, selectCountsTypes, widgetFilter]);
  const serviceAllWidgets = useCallback(async (value: string) => {
    const response: any = await GetWidgetsFilterWithPaginationService({
      search: value,
      perPage: 100
    });
    return response.data.map((item: any) => ({
      label: item.name,
      value: item.widgetId,
    }));
  }, []);
  const getAllAnalyticsFiltersChannels = async () => {
    const response: any = await GetAnalyticsFiltersService();
    const channels = response.channels.map((item: any) => ({
      label: item.channelName,
      value: item.channelId,
    }));
    setDataChannels(channels);
  };

  const getAllAnalyticsFiltersCountsTypes = async () => {
    const response: any = await GetAnalyticsFiltersService();

    if (Array.isArray(response.statusInquiry) && response.statusInquiry.length > 0) {
      const options = response.statusInquiry.map((item: any) => ({
        label: item.label,
        value: item.value,
      }));
      setDataCountsTypes(options);

      // ✅ Esto asegura que se establece antes de renderizar InputSearch
      if (!selectCountsTypes) {
        const firstOption = { label: options[0].label, value: options[0].value };
        setSelectCountsTypes(firstOption);
      }
    } else {
      setDataCountsTypes([]);
      setSelectCountsTypes(null);
    }
  };


  useEffect(() => {
    headerStore.setModule("Reportes", "");
    headerStore.setModuleItem("Nivel de satisfacción", "/admin/home");
    getAllAnalyticsFiltersChannels();
    getAllAnalyticsFiltersCountsTypes();
  }, []);

  useEffect(() => {
    if (startDateSatisfactionLevel && endDateSatisfactionLevel) {
      getDataSatisfactionLevel();
      setIsReloadData(!isReloadData);
    }
  }, [selectChannels, selectCountsTypes, endDateSatisfactionLevel, widgetFilter]);
  // Helper para leer la var CSS
  const readOnSurface = () =>
    getComputedStyle(document.documentElement)
      .getPropertyValue('--color-on-surface-variant-main')
      .trim() || '#22356a';
  const [onSurface, setOnSurface] = useState(readOnSurface());


  useEffect(() => {
    const el = document.documentElement;
    const update = () => {
      const next = readOnSurface();
      setOnSurface(prev => (prev !== next ? next : prev));
    };
    const obs = new MutationObserver(update);
    // Observa cambios de clase/data-theme/style (si cambias la var en :root style, lo detecta)
    obs.observe(el, { attributes: true, attributeFilter: ['class', 'data-theme', 'style'] });

    update(); // primer chequeo
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!responseDataGraphSatisfactionLevel) return;

    const formattedDates = responseDataGraphSatisfactionLevel.dates.map((d) =>
      hFormatDate(d, "dd-MM-yyyy")
    );

    const channelSeries = responseDataGraphSatisfactionLevel.channelValues.map((ch) => ({
      name: ch.channelName,
      data: ch.values.map((v) => Number(v) || 0),
    }));

    setSeriesData(channelSeries);

    const numSeries = channelSeries.length;
    setOptionsData({
      chart: {
        foreColor: onSurface, // <-- color global de textos
        type: "area",
        height: 350,
        zoom: { enabled: true, type: "x", autoScaleYaxis: true },
        toolbar: {
          show: true,
          tools: { download: true, selection: true, zoom: true, zoomin: true, zoomout: true, pan: true, reset: true },
          autoSelected: "zoom",
        },
      },
      theme: { palette: "palette8" },
      stroke: { curve: "straight", width: Array(numSeries).fill(3), dashArray: Array(numSeries).fill(0) },
      markers: { size: 5, hover: { sizeOffset: 3 } },
      dataLabels: { enabled: true, formatter: (val: number) => val.toString() },
      xaxis: {
        categories: formattedDates,
         labels: { rotate: -60, style: { fontSize: "10px", colors: onSurface } }, // labels usan "colors"
          title: { text: "Fechas", style: { fontSize: "12px", color: onSurface } }, // title usa "color"
      },
      yaxis: {
        min: 0,
        decimalsInFloat: 0,
        labels: { formatter: (val?: number) => (val != null ? val.toFixed(0) : "0"), style: { fontSize: "12px", colors: onSurface } },
        forceNiceScale: false,
      title: { text: "Nivel %", style: { fontSize: "12px", color: onSurface } },
      },
      legend: { show: true, position: "bottom", horizontalAlign: "center" },
    });
  }, [responseDataGraphSatisfactionLevel,onSurface]);

  const columns = [
    {
      header: "ID SESIÓN",
      field: "sessionId",
      render: (row: any) => <div style={{ width: "200px" }}>{row.sessionId}</div>,
    },
    {
      header: "FECHA INICIO",
      field: "",
      render: (row: any) => row.startDate ? <div>{hFormatDate(row.startDate, "dd-MM-yyyy hh:mm:ss a")}</div> : "",
    },
    {
      header: "ESTADO",
      field: "status",
    },
    {
      header: "WIDGET ID",
      field: "widgetId",
    },
    {
      header: "CÓDIGO CIUDADANO",
      field: "",
      render: (row: any) => row.citizen ? <div>{row.citizen.externalChannelId}</div> : "",
    },
    {
      header: "CANAL",
      field: "",
      render: (row: any) => row.citizen ? <div>{row.citizen.communicationChannel?.channelName}</div> : "",
    },
    {
      header: "OPCIONES",
      field: "",
      render: (row: any) => (
        <AppButton
          className={styleDataTable.buttom_option}
          variant="primary"
          iconName="edit"
          buttonText="Ver Conversación"
          onClick={() => handleView(row)}
        />
      ),
    },
  ];


  const handleView = async (row: any) => {
    if (!row || !row.sessionId) return;

    setIsOpen(true);
    setLoadingConversation(true);
    setConversationMessages([]);

    try {
      const params = { sessionId: row.sessionId };
      const response: any = await GetInquiryDetailsBySessionService(params);
      setConversationMessages(response);
    } catch (error) {
      console.error("Error fetching conversation details:", error);
      setConversationMessages([]);
    } finally {
      setLoadingConversation(false);
    }
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setConversationMessages([]);
    setLoadingConversation(false);
  };
  const handleFilterButtonClick = () => {
    setShowFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setShowFilterModal(false);
  };
  return (
    <div className={style.Dashboard_page}>
      <h4 className={style.under__line}><strong>Nivel de satisfacción:</strong></h4>
      {loading && <ProgressBar />}

      <div className={style.containerGraph} style={{ marginTop: "0.5rem" }}>
        <div className={style.containerFilters}>
          <div >
            <AppInputSearchFilter
              name="channels"
              textLabel="Selecciona canal"
              data={dataChannels}
              selected={selectChannels}
              onSelect={setSelectChannels}
              multiple={true}
            />
          </div>
          <div>
            <InputSearch
              key={selectCountsTypes?.value ?? 'empty'}
              classNameInput={styleForm.input__input}
              textLabel="Selecciona estado"
              data={dataCountsTypes}
              onSelect={setSelectCountsTypes}
              selected={selectCountsTypes || { label: "", value: "" }}
            />
          </div>
          <div
              className={style.container__select}
              style={{ minWidth: "280px" }}
            >
              <InputSearch
                key={crypto.randomUUID()}
                name="status"
                classNameInput={styleForm.input__input}
                textLabel="Selecciona widget"
                serviceCall={serviceAllWidgets}
                onSelect={(selected) => {
                  setWidgetFilter(selected);
                }}
                selected={widgetFilter}
              />
            </div>
        </div>

        <ChartComponent
          key={`satisfaction-${onSurface}`}  // remonta cuando cambia el color del tema

          titleChart="Nivel de satisfacción"
          typeGraph="bar"
          dataDashboard={seriesData}
          dataOptions={optionsData}
          onDateChange={(dateRange) => {
            if (dateRange) {
              setStartDateSatisfactionLevel(dateRange[0]);
              setEndDateSatisfactionLevel(dateRange[1]);
            }
          }}
        />

        <DataTable
          columns={columns}
          service={getSessionsWithPaginationService}
          reloadData={isReloadData}
          showSearch={false}
          params={{
            startDate: hFormatDate(startDateSatisfactionLevel, "yyyy-MM-dd"),
            endDate: hFormatDate(endDateSatisfactionLevel, "yyyy-MM-dd"),
            channelIds: selectChannels.map((c: any) => c.value),
            status: selectCountsTypes?.value ?? "",
            widgetId: widgetFilter ? widgetFilter.value : "",
          }}
          excelButton={{
            enabled: true,
            nameFile: `Lista de Sesiones`,
            getExcelData: (data) => {
              return data.map((row: any) => ({
                ID_SESIÓN: row.sessionId ?? "",
                FECHA_INICIO: row.startDate
                  ? hFormatDate(row.startDate, "dd-MM-yyyy hh:mm:ss a") // o new Date(row.startDate) si quieres celda de fecha real
                  : "",
                ESTADO: row.status ?? "",
                WIDGET_ID: row.widgetId ?? "",
                CÓDIGO_CIUDADANO: row.citizen?.externalChannelId ?? "",
                CANAL: row.citizen?.communicationChannel?.channelName ?? "",
              }));
            },
          }}
        >
          {''}
        </DataTable>

        <Modal
          title="Detalle de Conversación"
          isOpen={isOpen}
          onClose={handleCloseModal}
          size={{ width: "90%", maxWidth: "1400px", height: "80vh" }}
          loadingModal={false}
          footerContent={
            <div className={style.containerButtoms}>
              <button className={styleForm.buttomFooter + " " + styleForm.buttom_cancelar} onClick={handleCloseModal}>
                Cerrar
              </button>
            </div>
          }
        >
          <ConversationViewer messages={conversationMessages} loading={loadingConversation} />
        </Modal>
      </div>
    </div>
  );
}
